import React from 'react';
import { useUser } from '../../context/UserContext';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
    const { user, logout } = useUser();
    const navigate = useNavigate();
    const location = useLocation();

    const handleBack = () => {
        navigate('/home');
    };

    return (
        <header className="bg-[#252526] border-b border-[#3E3E42] px-6 py-6 relative flex items-center justify-center">
            {location.pathname !== '/home' && (
                <button
                    onClick={handleBack}
                    className="absolute left-6 top-1/2 transform -translate-y-1/2 bg-[#2D2D30] hover:bg-[#3E3E42] text-[#CCCCCC] font-semibold px-5 py-2 rounded-lg shadow transition duration-200"
                >
                    Назад
                </button>
            )}
            <h1 className="text-[#CCCCCC] text-lg font-semibold text-center">
                Добро пожаловать, {user?.user.username} - {user?.user.position?.name} - {user?.user.role}
            </h1>
            <button
                onClick={logout}
                className="absolute right-6 top-1/2 transform -translate-y-1/2 bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded-lg shadow transition duration-200"
            >
                Выйти
            </button>
        </header>
    );
};

export default Header; 